(() => {
  if (!String(document.documentElement.lang || '').toLowerCase().startsWith('he')) return;
  if (window.__NIMORA_QUICK_BUY_LOADED__) return;
  window.__NIMORA_QUICK_BUY_LOADED__ = true;

  const buttons = () => Array.from(document.querySelectorAll('[data-nimora-quick-buy]'));

  function context(button) {
    const root = button.closest('[id^="MainProduct-"]') || document;
    const productForm = root.querySelector('product-form');
    const form = productForm?.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const addButton = form?.querySelector('[name="add"]');
    const qtyInput = root.querySelector('.nimora-quantity-breaks__input');
    const quantity = Number(qtyInput?.value || 1);
    const bundleActive = root.classList?.contains('nimora-mixed-bundle-active') || quantity > 1;
    return { root, form, variantInput, addButton, bundleActive };
  }

  function sync(button) {
    const { variantInput, addButton, bundleActive } = context(button);
    const unavailable = !variantInput || !variantInput.value || variantInput.disabled || addButton?.disabled;
    const redirecting = button.getAttribute('aria-busy') === 'true';
    const shouldDisable = Boolean(unavailable || bundleActive || redirecting);

    if (button.disabled !== shouldDisable) button.disabled = shouldDisable;
    const ariaDisabled = shouldDisable ? 'true' : 'false';
    if (button.getAttribute('aria-disabled') !== ariaDisabled) button.setAttribute('aria-disabled', ariaDisabled);
  }

  function syncAll() {
    buttons().forEach(sync);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-nimora-quick-buy]');
    if (!button) return;
    event.preventDefault();

    sync(button);
    if (button.disabled) return;

    const { variantInput, bundleActive } = context(button);
    if (bundleActive || !variantInput?.value) return;

    const rootUrl = String(button.dataset.rootUrl || '/').replace(/\/$/, '');
    const checkoutUrl = `${rootUrl}/cart/${encodeURIComponent(variantInput.value)}:1`;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    window.location.assign(checkoutUrl);
  });

  document.addEventListener('change', () => requestAnimationFrame(syncAll), true);
  document.addEventListener('input', () => requestAnimationFrame(syncAll), true);
  document.addEventListener('variant:change', () => requestAnimationFrame(syncAll));

  const observer = new MutationObserver(() => requestAnimationFrame(syncAll));
  const start = () => {
    syncAll();
    document.querySelectorAll('[id^="MainProduct-"]').forEach((root) => {
      observer.observe(root, { attributes: true, subtree: true, attributeFilter: ['class', 'disabled', 'value'] });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
